/**
 * @file
 * A JavaScript file containing the sticky functionality
 */

(function(Drupal, $) {
  Drupal.behaviors.sticky = {
    attach: function(context) {
      $(".sticky", context)
        .once("sticky-processed")
        .addClass("sticky-processed")
        .each(function() {
          var dataOptions = $(this).data("stickybits");

          if (dataOptions.baseClass) {
            $(this).addClass(dataOptions.baseClass);
          }

          if ($('body').hasClass('toolbar-fixed')) {
            dataOptions.stickyBitStickyOffset += 79;
          }

          var options = {
            useStickyClasses: true,
            useFixed: dataOptions.useFixed,
            stickyBitStickyOffset: dataOptions.stickyBitStickyOffset,
            parentClass: dataOptions.parentClass,
            stickyClass: dataOptions.stickyClass,
            stuckClass: dataOptions.stuckClass,
            stickyChangeClass: dataOptions.stickyChangeClass
          };

          stickybits($(this).get(0), options);
        });
    }
  };
})(Drupal, jQuery);
